import { useRouter } from 'next/router';
import { useMemo } from 'react';

import Layout from '@/components/layout/Layout';
import { getResultRefundData } from '@/components/tax-refund/common/data/result-refund-data';
import HometaxEqualTinError from '@/components/tax-refund/common/view/ErrorView/HometaxEqualTinError';
import { COMMON_PATHS } from '@/lib/constants/paths';
import { ellipsisName } from '@/lib/utils/ellipsisName';

const ResultRequestEtcErrorPage = () => {
  const router = useRouter();

  const data = getResultRefundData();

  const taxpayerName = useMemo(() => {
    return ellipsisName(data?.taxpayerName, '고객');
  }, [data?.taxpayerName]);

  const handleRetry = () => {
    router.push({
      pathname: `${COMMON_PATHS.환급결정확인알림톡}`,
      query: router.query
    });
  };

  return (
    <Layout>
      <HometaxEqualTinError taxpayerName={taxpayerName} onPrimaryButtonClick={handleRetry} />
    </Layout>
  );
};

export default ResultRequestEtcErrorPage;
